import { Typography, Avatar, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { UserIcon } from 'assets';
import classnames from 'classnames';
import { isHipaaLink } from '../../../../config/productProfile';

import styles from './OrganizationInfo.module.scss';

type OrganizationInfoProps = {
  avatar?: string;
  organization: string;
  isAdmin: boolean;
  membersCount: number;
  className?: string;
  via3UserType?: 'Staff' | 'Member' | null;
};

export function OrganizationInfo({
  avatar,
  organization,
  isAdmin,
  membersCount,
  via3UserType,
  className,
}: OrganizationInfoProps) {
  const { t } = useTranslation('settings');

  return (
    <>
      <div
        className={classnames(styles.organizationInfo, className, {
          [styles.organizationInfoWithAvatar]: avatar,
        })}
      >
        {!!avatar && <Avatar className={styles.organizationPicture} src={avatar} />}

        <Grid className={styles.texts}>
          <Typography component='p' variant='body2' className={styles.name}>
            {organization ?? t('organizationInfo.noName')}
          </Typography>

          <Typography component='p' variant='body1' color='#979797' className={styles.roleText}>
            {isAdmin
              ? t('organizationInfo.admin')
              : isHipaaLink
              ? t('organizationInfo.provider')
              : via3UserType === 'Member'
              ? t('organizationInfo.member')
              : t('organizationInfo.staff')}
          </Typography>

          <div className={styles.membersCount}>
            <UserIcon color='secondary' className={styles.userIcon} />
            <Typography component='p' variant='body1' color='#979797'>
              {membersCount}
            </Typography>
          </div>
        </Grid>
      </div>
    </>
  );
}
